import React, { useState, useEffect } from 'react';
import TabNavigation from './Tabs';
import StorageStatus from './StorageStatus';
import StorageStatusContainer from './StorageStatusContainer';
import Button from '../Button';
import { Box, CircularProgress, Stack } from '@mui/material';
import { Overlay } from './StorageStatusContainer/StorageStatusContainer.styled';
import CleanupModal from './CleanupModal';
import DeleteFileModal from './DeleteFileModal';
import { ASSETS } from '../../utils/config';
import { getTotalMedia, getTotalStorage } from '../../services/api';
import { useSelector, useDispatch } from 'react-redux';
import { setStorage } from '../../redux/reducers/storage';
import StorageTable from './StorageTable';
import { toast } from 'react-toastify';
import StorageMediaModal from './StorageMediaModal';
import DowngradeModal from './DowngradeModal';
import TextView from '../TextView';
import { useGetAllSubcriptions } from "../../services/queries";
import { useNavigate } from 'react-router-dom';

const Storage = ({ onUpgradeClick = () => { } }) => {
  const [cleanupModal, setCleanupModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true); // Add loading state
  const [isMediaModalOpen, setIsMediaModalOpen] = useState(false);

  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const { data, isLoading, refetch } = useGetAllSubcriptions(
    value === 0 ? 40 : 10,
  );

  const {
    storageLimit,
    storageUsed,
    storageUsedPercentage,
  } = useSelector((state) => state.storage);

  const hasActiveProSuite = data?.data?.data?.some(sub => sub.name === "ProSuite" && sub.is_active);

  const fetchMedia = async () => {
    try {
      const response = await getTotalStorage();
      console.log('sitass', response.data.data);

      dispatch(setStorage(response.data.data)); // Dispatch setStorage action
    } catch (err) {
      console.error('Failed to fetch Media:', err);
    } finally {
      setLoading(false); // Set loading to false once data is fetched
    }
  };

  useEffect(() => {
    fetchMedia();
  }, [dispatch]);

  const [selectedWheel, setSelectedWheel] = useState({});
  const renderTabContent = () => {
    return <StorageTable type="wheels" fetchMedia={fetchMedia} onEditClick={(data) => {
      setSelectedWheel(data)
      setIsMediaModalOpen(true)
    }} />;

  };
  const nav = useNavigate()

  return (
    <div style={{ margin: '40px' }}>
      <Stack
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'flex-start'}
        alignItems={'center'}
        style={{ marginBottom: '20px', marginTop: '-20px' }}
      >
        <img
          src={ASSETS.BlueStorage}
          alt="blue"
          style={{ height: '40px', width: '40px', marginRight: '10px' }}
        />
        <Box>
          <TextView
            style={{ fontSize: '24px', lineHeight: '30px', fontWeight: '600', color: '#123051' }}
          >
            Storage
          </TextView>
          <TextView style={{ fontSize: '16px', fontWeight: '500' }}>
            Manage your account information
          </TextView>
        </Box>
      </Stack>
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <StorageStatusContainer
            storageUsed={storageUsed}
            storagePercent={storageUsedPercentage}
            totalStorage={storageLimit}
          />

          <Stack
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            style={{ padding: '15px', gap: '10px' }}
          >
            <TextView style={{ fontSize: '18px', fontWeight: '700' }}>My Wheels</TextView>
            {!hasActiveProSuite && (
              <Stack style={{ width: '12vw' }}>
                <Button onClick={() => onUpgradeClick('subscriptions')}>Upgrade</Button>

              </Stack>

            )}
          </Stack>
          {renderTabContent()}
          <StorageMediaModal isOpen={isMediaModalOpen} onClose={() => setIsMediaModalOpen(false)} wheelId={selectedWheel?.id} title={selectedWheel?.name} image={selectedWheel?.image} size={selectedWheel?.size} />

        </>
      )}
      {cleanupModal && (
        <>
          <Overlay onClick={() => setCleanupModal(false)} />
          <CleanupModal
            onClose={() => setCleanupModal(false)}
            storageUsed={storageUsed}
            storagePercent={storageUsedPercentage}
            totalStorage={storageLimit}
          />
          {/* <DeleteFileModal onClose={() => setIsModalOpen(false)} /> */}
        </>
      )}

      {deleteModal && (
        <>
          <Overlay onClick={() => setDeleteModal(false)} />
          <DeleteFileModal onClose={() => setDeleteModal(false)} />
        </>
      )}
      <DowngradeModal isOpen={false} onClose={() => { }} downgradeType={2} />
    </div>
  );
};

export default Storage;
